module.exports = __webpack_public_path__ + "static/flagImage-f08a9c60a0ec0cd2a37093e9c93f65ad.png";